import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(to top, #b5b5b5, #c2c2c2, #d0d0d0, #dedede, #ececec, #f0f0f0, #f3f3f5, #f7f7f9, #f1f2f5, #ebecf1, #e4e7ec, #dde2e8);
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 350px;
  justify-content: flex-end;
  border: 1px #333 solid;
  padding: 20px;
  border-radius: 6px;
`;

export const Button = styled.button`
  background-color: #333;
  color: #fff;
  height: 50px;
  width: 100%;
  border-radius: 4px;
`;

export const TextButton = styled.p`
 margin-left: 55px;
  color: #fff;
  
`;

export const ContainerButton = styled.div`
  display: flex;
  padding: 0 0 0 16px;
  align-items: center;
`;

export const styles = {
  button: {
    marginTop: 20,
  },
  containerCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
  },
};
